import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=5faa9bcc&scoped=true"
import script from "./PageTitle.vue?vue&type=script&lang=ts"
export * from "./PageTitle.vue?vue&type=script&lang=ts"
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=5faa9bcc&prod&lang=less"
import style1 from "./PageTitle.vue?vue&type=style&index=1&id=5faa9bcc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faa9bcc",
  null
  
)

export default component.exports